import * as types from './types';

const initialState = {
  BranchSummaryLogs: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
  case types.BRANCH_DETAIL_SUCCESS: {
    return {
      ...state,
      BranchSummaryLogs: action.payload
    };
  }
  case types.BRANCH_DETAIL_FAILURE:
    return { ...state, error: action.payload };

  default:
    return state;
  }
}
